import cloneDeep from 'lodash/cloneDeep'

import * as userListsAtom from 'src/atoms/user-lists'
import { userListsClient } from 'src/clients'
import { logEvent } from 'src/components/analytics'
import { useRecoilMutation, UseRecoilMutationOptions } from 'src/utils/recoil'

export const useDeleteUserList = (options?: UseRecoilMutationOptions<void>) => {
  return useRecoilMutation(
    ({ set }) =>
      async (id: string) => {
        await userListsClient.deleteList(id)
        logEvent('user-list', { action: 'delete' })
        set(userListsAtom.userLists, (userLists) => {
          const originalUserLists = cloneDeep(userLists) || []
          return originalUserLists.filter((list) => list.id !== id)
        })
      },
    [],
    { ...options }
  )
}
